// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  top: 26px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.for-sidebar-toggler {
  top: 22px !important;
  left: 9px !important;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 3.5px;
  bottom: 4.55px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #4BB3BC !important;
}

input:focus + .slider {
  box-shadow: 0 0 1px #4BB3BC;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.mid {
  margin-top: 27px;
}

.slider.round {
  height: 22px;
  border-radius: 19px;
  width: 48px;
}

.text-logo1 {
  padding-top: 50px;
  font-size: x-large;
}

.forTheImage {
  margin-top: -10px;
}

.for-position-credits {
  margin-left: 30px !important;
}

.sidebar-heading {
  margin-left: 80px;
  color: #6e768e;
  font-size: 15px;
}

.sidebar a:hover {
  color: #4BB3BC !important;
}`, "",{"version":3,"sources":["webpack://./src/components/AppLayout/LeftSidebar/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AACF;;AAEA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AACF;;AAEA;EAEE,oBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,mCAAA;EACA,+BAAA;EACA,2BAAA;AAAF;;AAGA,oBAAA;AACA;EACE,mBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACI,YAAA;EACA,mBAAA;EACA,WAAA;AAAJ;;AAGA;EACE,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAIA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;AADF","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n  top: 26px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.for-sidebar-toggler{\n  // top: 5px !important;\n  top: 22px !important;\n  left: 9px !important;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 13px;\n  width: 13px;\n  left: 3.5px;\n  bottom: 4.55px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #4BB3BC !important;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #4BB3BC;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.mid{\n  margin-top: 27px;\n}\n\n.slider.round {\n    height: 22px;\n    border-radius: 19px;\n    width: 48px;\n}\n\n.text-logo1{\n  padding-top: 50px;\n  font-size: x-large;\n}\n\n.forTheImage{\n  margin-top: -10px;\n}\n\n.for-position-credits{\n  margin-left: 30px !important;\n}\n\n\n.sidebar-heading{\n  margin-left: 80px;\n  color: #6e768e;\n  font-size: 15px;\n}\n\n.sidebar a:hover{\n  color: #4BB3BC !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
